"use client"
import {
  useDrawer
} from "./chunk-64A25YOZ.mjs";

// src/drawer-drag-bar.tsx
import { forwardRef, ui } from "@yamada-ui/core";
import { cx } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var DrawerDragBar = forwardRef(
  ({ className, __css, ...rest }, ref) => {
    const styles = useDrawer();
    const css = { ...styles.dragBar };
    return /* @__PURE__ */ jsx(
      ui.div,
      {
        ref,
        className: cx("ui-drawer__drag-bar", className),
        __css: css,
        ...rest
      }
    );
  }
);
DrawerDragBar.displayName = "DrawerDragBar";
DrawerDragBar.__ui__ = "DrawerDragBar";

export {
  DrawerDragBar
};
//# sourceMappingURL=chunk-5NLJNYIN.mjs.map